export const domainsConstants = {
  ADD_DOMAIN_REQUEST: 'ADD_DOMAIN_REQUEST',
  ADD_DOMAIN_SUCCESS: 'ADD_DOMAIN_SUCCESS',

  EDIT_DOMAIN_REQUEST: 'EDIT_DOMAIN_REQUEST',
  EDIT_DOMAIN_SUCCESS: 'EDIT_DOMAIN_SUCCESS',
  EDIT_DOMAIN_FAILURE: 'EDIT_DOMAIN_FAILURE',

  REMOVE_DOMAIN_REQUEST: 'REMOVE_DOMAIN_REQUEST',
  REMOVE_DOMAIN_SUCCESS: 'REMOVE_DOMAIN_SUCCESS',

  SET_DOMAINS_LIST_REQUEST: 'SET_DOMAINS_LIST_REQUEST',
  SET_DOMAINS_LIST_SUCCESS: 'SET_DOMAINS_LIST_SUCCESS',
  SET_DOMAINS_LIST_FAILURE: 'SET_DOMAINS_LIST_FAILURE',

  SET_DOMAIN_REQUEST: 'SET_DOMAIN_REQUEST',
  SET_DOMAIN_SUCCESS: 'SET_DOMAIN_SUCCESS',

  SET_DOMAIN_OFFER_REQUEST: 'SET_DOMAIN_OFFER_REQUEST',
  SET_DOMAIN_OFFER_SUCCESS: 'SET_DOMAIN_OFFER_SUCCESS',
  SET_DOMAIN_OFFER_FAILURE: 'SET_DOMAIN_OFFER_FAILURE',

  SET_DOMAIN_SETTINGS_REQUEST: 'SET_DOMAIN_SETTINGS_REQUEST',
  SET_DOMAIN_SETTINGS_SUCCESS: 'SET_DOMAIN_SETTINGS_SUCCESS',

  RESET_DOMAIN: 'RESET_DOMAIN',

  SET_DOMAIN_REPLICA_OFFERS_IDS: 'SET_DOMAIN_REPLICA_OFFERS_IDS',
};
